<div class="calendar">
  <div class="calendar-header">
    <div class="controls">
      <span class="js-calendar-prev {{#unless hasPrev}}disabled{{/unless}} calendar-prev">❮</span>
      <span class="js-calendar-next {{#unless hasNext}}disabled{{/unless}} calendar-next">❯</span>
    </div>
    <ul class="day-headers">
      {{#each dayHeaders}}
        <li class="day-header">
          <p class="day">{{ day }}</p>
          <p class="date">{{ date }}</p>
        </li>
      {{/each}}
    </ul>
  </div>

  <div class="calendar-body">
    {{#if isLoaded}}
      {{#each slotDays}}
        <div class="day">
          <ul class="slots">
            {{#each this}}
              {{#if spacer}}
                <li class="spacer">&nbsp;</li>
              {{else if more }}
                <li class="js-more more">more</li>
              {{else if next }}
                <li class="js-next next" data-index="{{ index }}">Next time is {{ pretty }}</li>
              {{else}}
                <li class="js-slot slot {{#if selected}}selected{{/if}}" data-start="{{ start }}" data-finish="{{ finish }}" data-duration="{{ duration }}">{{ pretty }}</li>
              {{/if}}
            {{/each}}
          </ul>
        </div>
      {{/each}}
    {{else if error}}
      <div class="calendar-error">
        <p class="title">Uh oh,</p>
        <p class="copy">we're having trouble loading appointments</p>
        <p class="retry js-retry">Let's try this again</p>
      </div>
    {{else}}
      <div class="calendar-loading">
        <div class="animation"></div>
        <p class="title">Hang tight,</p>
        <p class="copy">we're finding more times</p>
      </div>
    {{/if}}
  </div>

  <div class="calendar-footer">
    {{#if selection}}
      <p class="expert">Your Starry Expert will arrive</p>
      <p class="arrival">{{ selection.date }}, between {{ selection.start }}–{{ selection.finish }}</p>
      <p class="disclaimer">(please set aside {{ duration }} for installation)</p>
    {{else if isLoaded}}
      <p class="make-selection">Choose a date and time</p>
    {{/if}}
  </div>
</div>
